import styled from 'styled-components';

export const Wrapper = styled.label`
  column-gap: 10px;
  grid-template-columns: 80px 1fr;
  align-items: center;
  grid-auto-flow: column;
  display: grid;
  
  padding: 12px 16px 12px 49px;
  border-top: 1px solid ${({theme}) => `
    ${theme.variables.borderColor};
  `};
`;
